import React, { useRef, useState } from "react";
import styled from "styled-components";
import ArticleContent from "./ArticleContent";
import { GatsbyImage } from "gatsby-plugin-image";
//import ArticleMetaBar from "./ArticleMetaBar";

import ArticleHero from "./ArticleHero";
import ArticleDate from "./ArticleDate";
import ArticleReach from "./ArticleReach";
import MemoChildren from "../MemoChildren";

import useAnimationFrame from "../../hooks/useAnimationFrame";
import ArticlePartnerCredit from "./ArticlePartnerCredit";



const Article = ({ article }) => {

  return (
    <article>
      <ArticleHero
        authors={article.authors || undefined}
        datePublished={article.date_published || undefined}
        figure={<GatsbyImage image={article?.image?.imageFile?.childImageSharp?.gatsbyImageData} alt="" />}
        shortTitle={article.short_title}
        subtitle={article.excerpt}
        title={article.title}
      />
      <StyledArticleBody>
        {article.canonical_syndication && (
          <ArticlePartnerCredit article={article} />
        )}
        {article.content && (
          <ArticleContent article={article} />
        )}
      </StyledArticleBody>
      {article?.syndications?.length > 1 && (
          <ArticleReach syndications={article.syndications} showList={true} />
      )}
    </article>
  );
};

export default Article;

const StyledArticleBody = styled.div`
  position: relative;
  padding-bottom: 3em;
  &:not(:last-child) {
    padding-bottom: 1em;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 100%;
      max-width: var(--text-max-width);
      transform: translate3d(-50%,0,0);
      border-bottom: 1px solid currentColor;
      opacity: 0.2;
    }
  }
  @media ( min-width: 60em ) {
    padding-bottom: 6em;
    &:not(:last-child) {
      padding-bottom: 2em;
    }
  }
`;

/*
const ArticleContentWrap = ({children, article}) => {

  const [progress, setProgress] = useState(0);

  const elementRef = useRef(null);

  /* FIX RE-RENDER of ArticleMetaBar
  useAnimationFrame( deltaTime => {
    if ( ! elementRef.current ) return;

    const element = elementRef.current;
    const elementHeight = element.offsetHeight - ( window.innerHeight / 2 );
    const elementTop = element.getBoundingClientRect().top;
    const progress = Math.min(1, Math.max(0, (elementTop + elementHeight) / elementHeight));
    const formattedProgress = (1 - progress).toFixed(4);
    const newProgress = {
      decimal: formattedProgress,
      percentage: `${formattedProgress * 100}%`
    }
    setProgress(oldProgress => newProgress);
  });

  return (
    <div ref={elementRef}>
      <MemoChildren debug="render article metabar">
        <ArticleMetaBar article={article} progress={progress} />
      </MemoChildren>
      <MemoChildren debug="render article content">
        {children}
      </MemoChildren>
    </div>
  )
}
*/

